/**
 * Brand and UI tokens — single source for MUI, Amplify, and Stripe.
 * Values from `src/assets/brand/README.md`.
 */

export const BRAND_PRIMARY_MAIN = '#9388e7' as const;
export const BRAND_PRIMARY_LIGHT = '#b0a7ed' as const;
export const BRAND_PRIMARY_DARK = '#7a6fd9' as const;
export const BRAND_GRADIENT_START = '#a497e7' as const;
export const BRAND_GRADIENT_END = '#6964e7' as const;

export const FONT_FAMILY =
  '"Roboto", "Helvetica", "Arial", sans-serif' as const;

/** MUI `typography.subtitle2` — inventory label sticker header. */
export const STICKER_HEADER_TYPOGRAPHY = {
  fontFamily: FONT_FAMILY,
  fontSize: '0.875rem',
  fontWeight: 500,
  letterSpacing: '0.00714em',
  lineHeight: 1.2,
} as const;

/** Print size for sticker header (matches `STICKER_HEADER_TYPOGRAPHY.fontSize`). */
export const STICKER_HEADER_FONT_SIZE_PT = 10.5;

/** Monospace serial printed under the QR on inventory labels. */
export const STICKER_SERIAL_FONT_SIZE_PT = 11;
export const STICKER_SERIAL_FONT_WEIGHT = 600;

/** Cross-platform monospace stack (SF Mono on iOS, Consolas on Windows). */
export const STICKER_SERIAL_FONT_FAMILY =
  'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Courier New", monospace' as const;

export const STICKER_SERIAL_TYPOGRAPHY = {
  fontFamily: STICKER_SERIAL_FONT_FAMILY,
  fontWeight: STICKER_SERIAL_FONT_WEIGHT,
  letterSpacing: '0.02em',
  lineHeight: 1.1,
} as const;

/** Matches `InsightApp` main content `p` (theme spacing units). */
export const APP_SHELL_CONTENT_PADDING = 3;

/** Standard width for form / detail drawers (`AppDrawer`). */
export const APP_DRAWER_WIDTH_PX = 420;

/** MUI `palette.primary` */
export function buildMuiPrimaryPalette(): {
  main: string;
  light: string;
  dark: string;
  contrastText: string;
} {
  return {
    main: BRAND_PRIMARY_MAIN,
    light: BRAND_PRIMARY_LIGHT,
    dark: BRAND_PRIMARY_DARK,
    contrastText: '#ffffff',
  };
}

/** Stripe Elements `appearance.variables` */
export function getStripeAppearanceVariables(isDark: boolean): Record<string, string> {
  return {
    colorPrimary: BRAND_PRIMARY_MAIN,
    colorBackground: isDark ? '#2d2d2d' : '#ffffff',
    colorText: isDark ? '#ffffff' : '#1a1a1a',
    colorDanger: '#d32f2f',
    fontFamily: 'Roboto, system-ui, sans-serif',
    spacingUnit: '4px',
    borderRadius: '8px',
  };
}
